
<div class="container">
    <nav aria-label="breadcrumb" class="breadCust">
        <ol class="breadcrumb">
            <li class="breadcrumb-item"><a routerLink="/corporate/home">Home</a></li>
            <li class="breadcrumb-item"><a routerLink="/corporate/events">Manage Event</a></li>
            <li class="breadcrumb-item active" aria-current="page">{{header}} Event</li>
        </ol>
    </nav>
</div>

<div class="container">
    <div class="row">
        <div class="col-12 col-xl-9 col-lg-10 mt-1">
            <div class="card">
                <div class="card-content">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6 mt-1">
                                <div class="col-md-12 font-weight-bold">Event Name :</div>
                                <div class="col-md-12">{{eventDetails?.event_name}}</div>
                            </div>

                            <div class="col-md-6 mt-1">
                                <div class="col-md-12 font-weight-bold">Category :</div>
                                <div class="col-md-12">{{campaign}}</div>
                            </div>
                            <div class="col-md-6 mt-1" *ngIf="eventDetails?.event_url_id">
                                <div class="col-md-12 font-weight-bold">Event Id :</div>
                                <div class="col-md-12">{{eventDetails?.event_url_id}}</div>
                            </div>
                            <div class="col-md-6 mt-1" *ngIf="eventDetails?.event_url">
                                <div class="col-md-12 font-weight-bold">Event URL :</div>
                                <div class="col-md-12">{{eventDetails?.event_url}}</div>
                            </div>
                            <div class="col-md-6 mt-1">
                                <div class="col-md-12 font-weight-bold">Date / Time :</div>
                                <div class="col-md-12">  {{eventDetails?.event_date | date}} at {{eventDetails?.event_start_time }}  
                                    {{ eventDetails?.event_time_zone}}</div>
                            </div>
                            <div class="col-md-6 mt-1" *ngIf="eventDetails?.event_type_id!=128">
                                <div class="col-md-12 font-weight-bold">Address 1 :</div>
                                <div class="col-md-12">{{eventDetails?.event_address1}}</div>
                            </div>
                            <div class="col-md-6 mt-1" *ngIf="eventDetails?.event_type_id!=128">
                                <div class="col-md-12 font-weight-bold">Address 2 :</div>
                                <div class="col-md-12">{{eventDetails?.event_address2}}</div>
                            </div>
                            <div class="col-md-6 mt-1" *ngIf="eventDetails?.event_type_id!=128">
                                <div class="col-md-12 font-weight-bold">Country :</div>
                                <div class="col-md-12">{{country}}</div>
                            </div>
                            <div class="col-md-6 mt-1" *ngIf="eventDetails?.event_type_id!=128">
                                <div class="col-md-12 font-weight-bold">City, State, Zip :</div>
                                <div class="col-md-12">{{eventDetails?.event_city}}, {{eventDetails?.event_state}}, {{eventDetails?.event_zip}}</div>
                            </div>
                            <div class="col-md-6 mt-1" *ngIf="eventDetails?.event_shopping_url">
                                <div class="col-md-12 font-weight-bold">Shopping URL :</div>
                                <div class="col-md-12">{{eventDetails?.event_shopping_url}}</div>
                            </div>
                            <div class="col-md-6 mt-1" *ngIf="eventDetails?.event_host_pws">
                                <div class="col-md-12 font-weight-bold">Host URL :</div>
                                <div class="col-md-12">{{eventDetails?.event_host_pws}}</div>
                            </div>
                            <div class="col-md-6 mt-1">
                                <div class="col-md-12 font-weight-bold">Creation Date :</div>
                                <div class="col-md-12">{{eventDetails?.createdon | date}}</div>
                            </div>
                            <div class="col-md-6 mt-1" >
                                <div class="col-md-12 font-weight-bold">Last Updated On :</div>
                                <div class="col-md-12">{{eventDetails?.modifiedon | date}}</div>
                            </div>
                            <div class="col-md-12 mt-1">
                                <div class="col-md-12 font-weight-bold">Description</div>
                                <div class="col-md-12">{{eventDetails?.event_description}}</div>
                            </div>
                            <div class="col-md-6 mt-1" *ngIf="eventDetails?.resource_preview_url">
                                <div class="col-md-12 font-weight-bold">Image/Video :</div>
                                <div class="col-md-12">
                                    <img src="{{eventDetails?.resource_preview_url}}"
                                    (error)="setValue($event)" width="200px"
                                    title="" />
                                </div>
                                <div class='col-md-12' *ngIf="selectedImage">
                                    <img *ngIf="selectedImage.resource_type=='image'" [src]="selectedImage?.resource_preview_url" width='100px' height='auto'/>
                                    <video *ngIf="selectedImage.resource_type=='video'" height="auto" width="100%" [controls]='true'>
                                      <source [src]="selectedImage?.resource_preview_url" type="video/mp4">
                                      Your browser does not support the video.
                                    </video>
                                   </div>

                            </div>
                            <div class="col-md-6 mt-1" *ngIf="eventDetails?.theme_screenshot">
                                <div class="col-md-12 font-weight-bold">Theme :</div>
                                <div class="col-md-12">{{eventDetails?.theme_name}}</div>
                                <div class="col-md-12">
                                    <img src="{{eventDetails?.theme_screenshot}}" width="200px"
                                    (error)="setValue($event)"
                                    title="" />
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    <div class="card-footer">
                        <div class="form-group text-center mb-0">
                          <button type="button" (click)="onBack()" class="btn btn-round btn-margo-action">Back</button>
                        </div>
                      </div>  
                </div>
            </div>
        </div>

    </div>
</div>  
